import { render, staticRenderFns } from "./ClockStatusOverlay.vue?vue&type=template&id=188ac136&scoped=true&"
import script from "./ClockStatusOverlay.vue?vue&type=script&lang=js&"
export * from "./ClockStatusOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ClockStatusOverlay.vue?vue&type=style&index=0&id=188ac136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ac136",
  null
  
)

export default component.exports